
            import { CommonModule } from "@angular/common";
            import { HttpClientModule } from "@angular/common/http";
            import { NgModule } from "@angular/core";
            import { FormsModule } from "@angular/forms";
            import { SanitizerUrlPipe } from "./pipes/SanitizerUrlPipe.pipe";
            import { StrongFBSharedModule } from "./StrongFB-shared.module";


            import { StrongFBAutoCompleteWidgetComponent } from "./widgets/auto-complete/auto-complete.component";
                            
import { StrongFBButtonWidgetComponent } from "./widgets/button/button.component";
                            
import { StrongFBCardWidgetComponent } from "./widgets/card/card.component";
                            
import { StrongFBCheckBoxWidgetComponent } from "./widgets/check-box/check-box.component";
                            
import { StrongFBComponentWidgetComponent } from "./widgets/component/component.component";
                            
import { StrongFBCssImageWidgetComponent } from "./widgets/css-image/css-image.component";
                            
import { StrongFBDatepickerWidgetComponent } from "./widgets/date-picker/date-picker.component";
                            
import { StrongFBDialogWidgetComponent } from "./widgets/dialog/dialog.component";
                            
import { StrongFBEditorWidgetComponent } from "./widgets/editor/editor.component";
                            
import { StrongFBFileUploaderWidgetComponent } from "./widgets/file-uploader/file-uploader.component";
                            
import { StrongFBFormComponent } from "./widgets/form/form.component";
                            
import { StrongFBFormFieldWidgetComponent } from "./widgets/form-field/form-field.component";
                            
import { StrongFBIconWidgetComponent } from "./widgets/icon/icon.component";
                            
import { StrongFBInputWidgetComponent } from "./widgets/input/input.component";
                            
import { StrongFBLayoutComponent } from "./widgets/layout/layout.component";
                            
import { StrongFBRadioBoxWidgetComponent } from "./widgets/radio-box/radio-box.component";
                            
import { StrongFBSelectWidgetComponent } from "./widgets/select/select.component";
                            
import { StrongFBStatisticsCardWidgetComponent } from "./widgets/stat-card/stat-card.component";
                            
import { StrongFBTabWidgetComponent } from "./widgets/tab/tab.component";
                            
import { StrongFBTableWidgetComponent } from "./widgets/table/table.component";
                            
import { StrongFBTagsListWidgetComponent } from "./widgets/tags-list/tags-list.component";
                            
import { StrongFBTextAreaWidgetComponent } from "./widgets/textarea/textarea.component";
                            
import { StrongFBToggleWidgetComponent } from "./widgets/toggle/toggle.component";
import { CKEditorModule } from "@ckeditor/ckeditor5-angular";
                            

            @NgModule({
                declarations: [
                    SanitizerUrlPipe,

                   StrongFBAutoCompleteWidgetComponent,
StrongFBButtonWidgetComponent,
StrongFBCardWidgetComponent,
StrongFBCheckBoxWidgetComponent,
StrongFBComponentWidgetComponent,
StrongFBCssImageWidgetComponent,
StrongFBDatepickerWidgetComponent,
StrongFBDialogWidgetComponent,
StrongFBEditorWidgetComponent,
StrongFBFileUploaderWidgetComponent,
StrongFBFormComponent,
StrongFBFormFieldWidgetComponent,
StrongFBIconWidgetComponent,
StrongFBInputWidgetComponent,
StrongFBLayoutComponent,
StrongFBRadioBoxWidgetComponent,
StrongFBSelectWidgetComponent,
StrongFBStatisticsCardWidgetComponent,
StrongFBTabWidgetComponent,
StrongFBTableWidgetComponent,
StrongFBTagsListWidgetComponent,
StrongFBTextAreaWidgetComponent,
StrongFBToggleWidgetComponent
                ],
                imports: [
                    StrongFBSharedModule,
                    CommonModule,
                    FormsModule,
                    HttpClientModule,
                    CKEditorModule,
                ],
                providers: [],
                exports: [
                    StrongFBAutoCompleteWidgetComponent,
StrongFBButtonWidgetComponent,
StrongFBCardWidgetComponent,
StrongFBCheckBoxWidgetComponent,
StrongFBComponentWidgetComponent,
StrongFBCssImageWidgetComponent,
StrongFBDatepickerWidgetComponent,
StrongFBDialogWidgetComponent,
StrongFBEditorWidgetComponent,
StrongFBFileUploaderWidgetComponent,
StrongFBFormComponent,
StrongFBFormFieldWidgetComponent,
StrongFBIconWidgetComponent,
StrongFBInputWidgetComponent,
StrongFBLayoutComponent,
StrongFBRadioBoxWidgetComponent,
StrongFBSelectWidgetComponent,
StrongFBStatisticsCardWidgetComponent,
StrongFBTabWidgetComponent,
StrongFBTableWidgetComponent,
StrongFBTagsListWidgetComponent,
StrongFBTextAreaWidgetComponent,
StrongFBToggleWidgetComponent
                ],
            })
            export class StrongFBModule { }

            /************************************/
            /**GENERATED*BY*STRONG*FORM*BUILDER**/
            /************************************/

                    